import { MigrationSpec } from "../migration.models"

const aiPromptRoles: MigrationSpec = {
  type: "MIGRATE_AI_PROMPT_ROLES",
  collection: "AiPrompts",
  risk: "DESTRUCTIVE",
  title: {
    en: "AI prompts → one per (name, role)",
    tr: "AI promptları → (isim, rol) başına bir kayıt"
  },
  description: {
    en:
      "Drops the pre-roles unique index on `name`, backfills `role: null` (the shared row every " +
      "AI role falls back to), unsets the removed `env` field on rows and inside `versions[]`, " +
      "then builds the current unique index.",
    tr:
      "AiPrompts.name üzerindeki rol öncesi unique indeksi düşürür, `role: null` (her AI rolünün " +
      "geri düştüğü paylaşımlı satır) yazar, kaldırılmış `env` alanını hem satırlardan hem " +
      "`versions[]` içinden siler, ardından güncel unique indeksi kurar."
  },
  // Two independent pieces of work share this migration: a row can need either or both.
  affectedFilter: {
    $or: [
      { role: { $exists: false } },
      { env: { $exists: true } },
      { "versions.env": { $exists: true } }
    ]
  },
  sampleFields: ["name", "usage", "role", "env"],
  indexes: {
    mustDrop: [{ keys: { name: 1 }, unique: true }],
    // `syncIndexes()` builds whatever the schema declares, which has since grown the engine
    // layer — see the MIGRATE_AI_PROMPT_ENGINE_VERSIONS migration.
    mustExist: [{ keys: { name: 1, role: 1, engineVersion: 1 }, unique: true }]
  },
  preview: (doc) => ({ ...doc, role: doc.role ?? null, env: "<removed>" }),
  notes: [
    {
      en:
        "Until this runs, no role-specific prompt override can be created; every role keeps " +
        "resolving to the shared row.",
      tr:
        "Bu çalışmadan role özel prompt override'ı oluşturulamaz; her rol paylaşımlı satıra " +
        "düşmeye devam eder."
    }
  ]
}

export default aiPromptRoles
